var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.825,
    height: 17.872,
    viewBox: "0 0 24.825 17.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_183",
    "data-name": "Tracciato 183",
    d: "M8.329,15.48l14.2-14.15a1.379,1.379,0,0,1,1.95,1.95L9.3,18.4a1.383,1.383,0,0,1-1.95,0l-6.9-6.874a1.379,1.379,0,0,1,1.95-1.95Z",
    transform: "translate(-0.053 -0.926)",
    fill: "#4a9d77",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c59622b99fa7f4b2aaeeff15829a9382.svg";
export { ForwardRef as ReactComponent };